module.exports = __webpack_public_path__ + "assets/img/wholetone.7ef22003.gif";